import { UserBasic } from '../../../domain/value-object/UserBasicVO'

/**
 * チケットタイプのグリッド行データ型
 * BulkSheetViewで表示される行データの型定義
 */
export type TicketTypeRow = {
  uuid: string
  name: string
  code: string
  iconUrl?: string
  isUsed?: boolean
  isPreset?: boolean
  displayOrder?: number // 表示順序（ドラッグ&ドロップ用、undefinedの場合は未設定）
  createdAt: number
  createdBy?: UserBasic
  updatedAt: number
  updatedBy?: UserBasic
  // BulkSheetViewで使用される追加プロパティ
  isAdded?: boolean
  isEdited?: boolean
}

export const isDeletableTicketTypeRow = (row: TicketTypeRow): boolean => {
  return !row.isPreset && !row.isUsed
}
